import { authenticationService } from '../services';

export function authHeader() {
    const user = authenticationService.getUser();
    //console.log("Current user add tenant:", localStorage.getItem('acamob_current_user'), currentUser && currentUser.user && currentUser.user.tenant);
    return { "Authorization": user && `Bearer ${user?.accessToken}` || null }
}